import FormattedAddress from "components/Atoms/FormattedAddress";
import React from "react";
import { isAdminAndVisitingAddressSame } from "shared/utils/companyUtils";
interface Props {
  company: server.dto.Company
}

export const VisitingAddress = ({ company }: Props) => {
  return <div>
    <div>{company.name}</div>
    <FormattedAddress address={company.address} />
  </div>;
}

export const PostalAddress = ({ company }: Props) => {
  const isSameAsVisitingAddress = isAdminAndVisitingAddressSame(company);
  if (isSameAsVisitingAddress) {
    return <>{RESX.Company.SameAsVisitingAddress}</>;
  }

  return <div>
    <div>{company.admName}</div>
    <FormattedAddress address={company.admAddress} />
  </div>
};